export const brand = {
  name: "BRECCS",
  tagline: "Know what is happening. Know what is at risk. Know what to do next.",
  descriptor:
    "BRECCS Zimbabwe — Business, Records, Education, Commerce, Care & Services. The operating infrastructure behind every school.",
  city: "Harare",
  country: "Zimbabwe",
  company: "BRECCS Zimbabwe",
  domain: "breccs.co.zw",
  logoUrl: "/images/image.png",
};

export const subBrands = [
  { name: "BRECCS Command", desc: "Exception-driven control centre" },
  { name: "BRECCS Money", desc: "Collections, reconciliation & billing" },
  { name: "BRECCS Records", desc: "Learner, family & staff identity" },
  { name: "BRECCS Learn", desc: "Zimbabwe education & assessment" },
  { name: "BRECCS Supply", desc: "Procurement intelligence & inventory" },
  { name: "BRECCS Nourish", desc: "School feeding operations" },
  { name: "BRECCS Canteen", desc: "Cashless school commerce" },
  { name: "BRECCS Transit", desc: "Safe transport & verified handover" },
  { name: "BRECCS Boarding", desc: "Residential school operations" },
  { name: "BRECCS Family", desc: "Parent experience" },
  { name: "BRECCS Intelligence", desc: "Governed decision support" },
  { name: "BRECCS Connect", desc: "Integrations & communication" },
  { name: "BRECCS Institutional", desc: "Authorised aggregate intelligence" },
];
